<!-- 
  批量话费流量充值
  lovi 2020-07-30
 -->
<template>
  <div class="recharge">
    <div class="breadcrumb-wrap">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/">{{ $t("common.eepay") }}</BreadcrumbItem>
        <BreadcrumbItem>{{ $t("common.batchRecharge") }}</BreadcrumbItem>
      </Breadcrumb>
      <a
        class="returnA"
        @click="returnFun"
        v-if="(tabNum == 0 && nextStepFlag) || tabNum == 1 || tabNum == 2"
      >
        {{ $t("common.back") }}
      </a>
    </div>
    <div class="recharge-type" v-if="tabNum == 0 && !nextStepFlag">
      <a
        href="javascript:void(0);"
        :class="{ active: rechargeType == 0 }"
        @click="changeType(0)"
        >{{ $t("recharge.batchPhoneFee") }}</a
      >
      <a
        href="javascript:void(0);"
        :class="{ active: rechargeType == 1 }"
        @click="changeType(1)"
        >{{ $t("recharge.batchDataTraffic") }}</a
      >
    </div>
    <step :tabNum="tabNum" />

    <div class="step-content">
      <div v-show="tabNum == 0" class="tab1">
        <template v-if="!nextStepFlag">
          <number-enter
            ref="numberEnter"
            v-for="(item, index) in numberInfo"
            :key="index"
            :rechargeType="rechargeType"
            :operatorTitle="item.title"
            :operatorType="item.type"
            :tagList.sync="tagList"
            :operatorList="operatorList"
            :allMoney="allMoney"
          />
          <div class="button-wrap">
            <Button type="primary" long @click="nextStep">
              {{ $t("common.nextStep") }}
            </Button>
            <p>{{ $t("recharge.rechargeLimitTips") }}</p>
          </div>
        </template>
        <template v-if="nextStepFlag">
          <number-list
            v-if="nextStepFlag"
            :nextStepFlag.sync="nextStepFlag"
            :rechargeType="rechargeType"
            :numberList.sync="numberList"
            :operatorState="operatorState"
            :curPay.sync="curPay"
            @getParams="getParams"
          />
        </template>
      </div>
      <div v-if="tabNum == 1" class="tab2 sweep-code">
        <p>
          {{
            rechargeType == 1
              ? $t("recharge.batchDataTrafficRecharge")
              : $t("recharge.batchPhoneFeeRecharge")
          }}
        </p>
        <div class="password" v-if="curPay.payment_id == 3">
          <h5>{{ rechargeParams.totalMoney }}P</h5>
          <div class="inputPsd">
            <Input
              v-model="payPsd"
              type="password"
              password
              :placeholder="$t('common.enterPayPsd')"
            />
          </div>
          <div class="button-wrap">
            <Button type="primary" long @click="submitJump">
              {{ $t("common.confirm") }}
            </Button>
          </div>
        </div>
        <!-- 微信支付 -->
        <pay-code
          v-if="curPay.payment_id == 5"
          :money="rechargeParams.totalMoney"
          :type="curPay.payment_id"
          :data="payMentInfo"
          @getPayCode="getPayCode"
        />
      </div>
      <div v-if="tabNum == 2" class="tab3">
        <detail
          v-if="detailFlag"
          :order_id="payMentInfo.order_id"
          :type="rechargeType == 0 ? 20 : 21"
          @getSubOrder="getSubOrder"
        />
        <!-- 批量充值子订单充值记录 -->
        <sub-order
          v-if="subOrderFlag"
          :subOrderFlag.sync="subOrderFlag"
          :data="subOrderData"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Step from "@/components/recharge/step";
import NumberEnter from "@/components/recharge/numberEnter";
import NumberList from "@/components/recharge/numberList";
import PayCode from "@/components/payCode";
import Detail from "@/components/detail";
import SubOrder from "@/components/detail/subOrder";
export default {
  name: "recharge-batch",
  components: {
    Step,
    NumberEnter,
    NumberList,
    PayCode,
    Detail,
    SubOrder
  },
  data() {
    return {
      operatorList: [], //运营商列表
      numberInfo: [],
      numberList: [], //下一步展示的号码列表
      phoneBatch: [], //号码验证运营商数组
      phoneBatchInfo: {}, //页面信息,仅流量
      tagList: [], //电话簿标签列表

      operatorState: {}, // 运营商支持流量套餐状态
      allMoney: {}, // 全部金额面板
      curPay: {}, // 支付方式
      rechargeParams: {}, // 充值参数
      payMentInfo: {}, // 支付信息

      rechargeType: 0, //充值类型，0为话费，1为流量
      tabNum: 0,
      nextStepFlag: false, //下一步
      payPsd: "", //余额充值的支付密码

      detailFlag: false, // 详情页Flag
      subOrderFlag: false, // 子订单Flag
      subOrderData: {} // 子订单数据
    };
  },
  created() {
    let vm = this;
    vm.getFetchOperatorPre();
    vm.getCallsDenomination();
    vm.operatorDataPackageState();
    vm.getUserMobileTags();
    vm.initialize();
  },
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    initialize() {
      //初始化信息
      let vm = this;
      vm.numberInfo = [];
      if (vm.rechargeType == 1) {
        for (let i = 0; i < 2; i++) {
          let obj = {};
          obj.title = [];
          obj.type = i + 1;
          obj.list = [];
          if (i == 0) {
            obj.title = ["Globe", "Smart", "Sun", "Tm"];
          } else {
            obj.title = ["Tnt"];
          }
          vm.numberInfo.push(obj);
        }
      } else {
        let obj = {};
        obj.title = [];
        obj.type = 0;
        obj.list = [];
        vm.numberInfo.push(obj);
      }
      console.log("numberInfo", vm.numberInfo);
    },
    changeType(type) {
      //修改充值类别
      let vm = this;
      vm.rechargeType = type;
      vm.initialize();
    },
    returnFun() {
      //返回按钮
      let vm = this;
      if (vm.tabNum == 0) {
        if (vm.nextStepFlag) {
          vm.nextStepFlag = false;
        }
      } else if (vm.tabNum == 1) {
        vm.tabNum = 0;
      } else if (vm.tabNum == 2) {
        if (vm.subOrderFlag) {
          vm.detailFlag = true;

          vm.subOrderFlag = false;
          vm.subOrderData = {};
        } else {
          vm.tabNum = 0;
          vm.nextStepFlag = false;

          vm.detailFlag = false;
          vm.payMentInfo = {};

          vm.subOrderFlag = false;
          vm.subOrderData = {};
        }
      }
    },
    getSubOrder(data) {
      // 获取子订单数据
      let vm = this;
      console.log("getSubOrder", data);
      vm.detailFlag = false;
      vm.subOrderFlag = true;
      vm.subOrderData = data;
    },
    getPayCode() {
      // 获取支付信息
      this.tabNum = 2;
      this.detailFlag = true;
    },
    nextStep() {
      //点击下一步
      let vm = this;
      let inputDate = [];
      for (let i = 0; i < vm.$refs.numberEnter.length; i++) {
        //vm.$refs.number[i].getClassify()调用number组件的getClassify()方法，获取输入的号码数据
        inputDate.push(vm.$refs.numberEnter[i].getClassify());
      }
      //判断当前是否有号码
      let hasNum = false;
      for (let i = 0; i < inputDate.length; i++) {
        if (inputDate[i].arr.length) {
          hasNum = true;
          break;
        }
      }
      if (!hasNum) {
        vm.$Message.info(vm.$t("common.enterMobile"));
        return false;
      }
      //判断是否有错误号码
      let hasError = false;
      for (let i = 0; i < inputDate.length; i++) {
        if (inputDate[i].error) {
          hasError = true;
          break;
        }
      }
      if (hasError) {
        vm.$Modal.confirm({
          content: vm.$t("recharge.wrongNumberTips"),
          onOk: () => {
            for (let i = 0; i < inputDate.length; i++) {
              if (inputDate[i].error) {
                //去错去重
                vm.$refs.numberEnter[i].deleteSubmit(0);
              }
            }
          }
        });
        return;
      }
      //判断是否有重复号码
      let hasRepeat = false;
      for (let i = 0; i < inputDate.length; i++) {
        if (inputDate[i].repeat) {
          hasRepeat = true;
          break;
        }
      }
      if (hasRepeat) {
        vm.$Modal.confirm({
          content: vm.$t("recharge.duplicateNumberTips"),
          onOk: () => {
            inputDate = [];
            for (let i = 0; i < vm.$refs.numberEnter.length; i++) {
              inputDate.push(vm.$refs.numberEnter[i].getClassify(true));
            }
            vm.numberProcessing(inputDate);
          }
        });
        return;
      }
      vm.numberProcessing(inputDate);
    },
    numberProcessing(inputDate) {
      // 号码列表处理
      let vm = this;
      vm.numberList = [];
      for (let i = 0; i < inputDate.length; i++) {
        if (!inputDate[i].arr.length) {
          continue;
        }
        for (let j = 0; j < inputDate[i].arr.length; j++) {
          vm.numberList.push(inputDate[i].arr[j]);
        }
      }
      console.log("numberList", vm.numberList);
      vm.nextStepFlag = true;
    },
    getParams(data) {
      // 获取充值参数
      let vm = this;
      console.log("getParams", data);
      vm.rechargeParams = data;
      if (vm.curPay.payment_id == 3) {
        vm.tabNum = 1;
      } else if (vm.curPay.payment_id == 5) {
        vm.payBatchCalls();
      }
    },
    submitJump() {
      // 余额充值
      let vm = this;
      if (vm.payPsd == "") {
        vm.$Message.info(vm.$t("common.enterPayPsd"));
        return;
      }
      if (vm.rechargeParams.totalMoney > Number(vm.userInfo.money_usable)) {
        vm.$Message.info(vm.$t("recharge.insufficientBalanceChooseOtherPay"));
        return false;
      }
      vm.rechargeParams.pay_password = vm.payPsd;
      vm.payBatchCalls();
    },
    payBatchCalls() {
      // 话费流量批量充值
      let vm = this;
      let params = {};
      params = vm.rechargeParams;
      vm.$post("/app/recharge/payBatchCalls", params, { loading: true }).then(
        res => {
          console.log("payBatchCalls", res);
          vm.payMentInfo = res;
          if (vm.curPay.payment_id == 3) {
            // 3.余额
            vm.detailTips = true;
            vm.tabNum = 2;
            vm.detailFlag = true;
          }
          if (vm.curPay.payment_id == 5) {
            vm.tabNum = 1;
          }
        }
      );
    },
    getUserMobileTags() {
      // 电话簿标签列表
      let vm = this;
      vm.$post("/app/user/userMobileTags", {}, { loading: true }).then(res => {
        console.log("userMobileTags", res);
        vm.tagList = res.list;
      });
    },
    operatorDataPackageState() {
      // 运营商支持流量套餐状态
      let vm = this;
      vm.$post(
        "/app/recharge/operatorDataPackageState",
        {},
        { loading: true }
      ).then(res => {
        console.log("operatorDataPackageState", res);
        vm.operatorState = res;
      });
    },
    getCallsDenomination() {
      // 话费充值面板
      let vm = this;
      vm.$post(
        "/app/recharge/callsDenomination",
        { type: 20 },
        { loading: true }
      ).then(res => {
        console.log("callsDenomination", res);
        vm.allMoney = res.list;
      });
    },
    getFetchOperatorPre() {
      //获取运营商字段
      let vm = this;
      vm.$post(
        "/app/index/fetchOperatorPre",
        {},
        {
          loading: true
        }
      ).then(res => {
        console.log("fetchOperatorPre", res);
        vm.operatorList = res.list;
      });
    }
  },
  watch: {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.recharge-type {
  margin-top: 15px;
  height: 45px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #bfbfbf;
  a {
    height: 100%;
    font-size: 18px;
    color: #4a4a4a;
    display: flex;
    align-items: center;
    &.active {
      color: #2042ab;
      position: relative;
      &:after {
        content: "";
        width: 100%;
        height: 4px;
        border-radius: 2px;
        background: #2042ab;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
  }
  a + a {
    margin-left: 50px;
  }
}

.step-content {
  padding: 0 50px;
  /deep/.detail-wrap,
  /deep/.list-wrap {
    padding: 0;
  }
  .sweep-code {
    text-align: center;
    h5 {
      color: #2042ab;
      font-size: 28px;
      padding: 10px;
    }
    .code {
      width: 200px;
      height: 200px;
      margin: 0 auto;
      img {
        width: 100%;
        max-width: 100%;
        max-height: 100%;
      }
    }
    p {
      font-size: 16px;
      color: #4a4a4a;
      padding: 10px;
    }
    .password {
      width: 300px;
      margin: 0 auto;
      .inputPsd {
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #2042ab;
        border-radius: 5px;
        /deep/.ivu-input {
          border: 0;
          height: 46px;
          padding-right: 40px;
          line-height: 46px;
          font-size: 16px;
          color: #2042ab;
        }
        /deep/.ivu-input-suffix {
          cursor: pointer;
          width: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          .ivu-icon {
            font-size: 22px;
            color: #2042ab;
          }
        }
      }
    }
  }
}
</style>
